/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'

export default function Boards2({ ...props }) {
  const group = useRef()
  const { nodes, materials } = useGLTF('/ModelsGLB/Class/Boards2.glb')
  return (
    <group ref={group} {...props} dispose={null}>
      <mesh geometry={nodes.BoardBody.geometry} material={materials['MI_Chalkboard_Green.002']} position={[-0.9, 0.9, -9.81]} scale={0.01} />
      <mesh geometry={nodes.Corkboard_153.geometry} material={materials['MI_Corkboard_Metallic.003']} position={[-4.18, 0.9, 3.3]} rotation={[Math.PI, 0, Math.PI]} scale={0.01} />
      <mesh geometry={nodes.Corkboard_152.geometry} material={materials['MI_Corkboard_Metallic.003']} position={[2.41, 0.9, 3.3]} rotation={[Math.PI, 0, Math.PI]} scale={0.01} />
      <mesh geometry={nodes.Corkboard_80.geometry} material={materials['MI_Corkboard_Metallic.003']} position={[2.5, 0.9, -9.81]} scale={0.01} />
      <mesh geometry={nodes.Corkboard_151.geometry} material={materials['MI_Corkboard_Metallic.003']} position={[-4.09, 0.9, -9.81]} scale={0.01} />
      <mesh geometry={nodes.Box001.geometry} material={materials['BoardFront.002']} position={[-0.9, 0.94, 3.28]} scale={0.01} />
    </group>
  )
}

useGLTF.preload('/Boards2.glb')
